<template>
    <div class="ChatThread flex flex-col">
        <div class="chat-header clearfix">
            <div v-if="!loading" class="flex v-center">
                <img
                    :src="other.user.avatar_url"
                    :alt="other.user.name"
                    class="chat-avatar spark-profile-photo-md"
                />
                <div class="flex-1 m-l-lg">
                    <div class="chat-title">
                        <a v-if="thread.subject" :href="thread.subject_url">
                            {{ thread.name }}
                        </a>
                        <p v-else class="m-b-none">
                            {{ thread.name }}
                        </p>
                    </div>
                    <div v-if="thread.subject" class="chat-subtitle">
                        {{ other.user.name }}
                    </div>
                </div>
            </div>
        </div>

        <div ref="chatHistory" class="chat-history flex-1">
            <PageLoader v-if="loading" />
            <ul v-else class="min-h-full m-0 flex flex-col justify-end">
                <li v-for="message in messages" :key="message.id" class="clearfix">
                    <ChatMessage :message="message" :participant="getParticipant(message)" />
                </li>

                <li v-if="sending" class="clearfix">
                    <ChatMessage :message="sending" :participant="me" />
                </li>
            </ul>
        </div>

        <ChatForm
            :form="form"
            :disabled="sending !== null"
            :locked="locked"
            @submit="send"
            @active="scrollBottom"
        />
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

@green: #86bb71;
@blue: #94c2ed;
@orange: #e38968;
@gray: #92959e;

.ChatThread {
    .chat-header {
        padding: 20px;
        border-bottom: 2px solid @body-bg;

        .chat-title {
            font-weight: bold;
            font-size: 16px;
        }

        .chat-subtitle {
            color: @gray;
        }
    }

    .chat-history {
        padding: 10px;
        border-bottom: 2px solid @body-bg;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;

        ul {
            padding: 0;
        }

        li {
            list-style: none;
        }
    }

    @media (max-width: @screen-xs-max) {
        .chat-header {
            padding: 10px;
        }

        .chat-history {
            padding-bottom: 0;
        }
    }
}
</style>

<script type="text/babel">
import ChatForm from 'dashboard-js/components/chat/ChatForm'
import ChatMessage from 'dashboard-js/components/chat/ChatMessage'
import ChatProvider from 'dashboard-js/providers/ChatProvider'
import PageLoader from 'dashboard-js/components/utilities/PageLoader'

export default {
    components: { ChatForm, ChatMessage, PageLoader },

    props: ['thread', 'messages'],

    data() {
        return {
            form: new SparkForm({
                body: null,
            }),
            sending: null,
        }
    },

    computed: {
        loading() {
            return this.messages === null
        },
        locked() {
            return this.$get(this.thread, 'is_locked', true)
        },
        me() {
            return this.$get(this.thread, 'participants').find(participant => {
                return participant.is_me === true
            })
        },
        other() {
            return this.$get(this.thread, 'participants').find(participant => {
                return participant.is_me === false
            })
        },
    },

    watch: {
        messages() {
            this.scrollBottom()
        },
    },

    mounted() {
        this.scrollBottom()
    },

    methods: {
        cancelPreview() {
            this.sending = null
        },

        finalizeMessageSent(message) {
            this.cancelPreview()
            this.form.body = ''
            this.$emit('sent', message)
        },

        getParticipant(message) {
            return this.$get(this.thread, 'participants').find(participant => {
                return (
                    participant.user_id === message.user_id &&
                    participant.user_type === message.user_type
                )
            })
        },

        previewMessage(body) {
            this.sending = { body }
            this.scrollBottom()
        },

        scrollBottom() {
            try {
                this.$nextTick(() =>
                    $(this.$refs.chatHistory).scrollTop(this.$refs.chatHistory.scrollHeight)
                )
            } catch (e) {
                // Issue with jQuery not instantiated when instantiating Turbolinks
                // Hopefully fixed in the next Turbolinks update...
            }
        },

        send() {
            this.previewMessage(this.form.body)

            ChatProvider.send(this.thread.id, this.form)
                .then(this.finalizeMessageSent)
                .catch(() => {
                    $(this.$el)
                        .find('textarea')
                        .focus()
                    this.cancelPreview()
                })
        },
    },
}
</script>
